import React, { useContext, useEffect } from 'react';

import { AUDIO_TYPE } from './../../ricos-content';
import { PluginsEventsContext } from './../../ricos-context';
import type { AudioNode } from './../../ricos-schema/next-schema';
import { HTMLData_Source } from './../../ricos-schema/next-schema';

import { HtmlViewer as HtmlComponent } from '../../plugin-html/viewer/html-viewer';
import { AUDIO_TYPES } from '../consts';
import type { AudioPluginEditorConfig } from '../types';

interface Props {
  node: AudioNode;
  settings: AudioPluginEditorConfig;
}

const AudioEmbedViewer: React.FC<Props> = ({ node, settings }) => {
  const pluginsEvents = useContext(PluginsEventsContext) || {};
  const nodeId = node.id;
  const html = node.audioData?.html;
  const url = node.audioData?.audio?.src?.url ?? '';

  const htmlCompProps = {
    htmlData: {
      html,
      source: HTMLData_Source.HTML,
      containerData: {
        width: {
          custom: '100%',
        },
        height: {
          custom: '100%',
        },
        url,
      },
    },
    settings,
  };

  useEffect(() => {
    nodeId &&
      pluginsEvents?.publishMediaPluginsDetails?.({
        pluginId: AUDIO_TYPE,
        nodeId,
        creator: undefined,
        title: undefined,
        track_duration: undefined,
        type: AUDIO_TYPES.spotify,
        url,
      });
  }, []);

  return <HtmlComponent {...htmlCompProps} />;
};

export default AudioEmbedViewer;
